module.exports = "<div class=\" row loading-row\">\n    <div class=\"col-12 center-block text-center\">\n        <i class=\"fas fa-spinner fa-pulse\"></i> <br>\n        <span class=\"loading-text\">{{loadingMessage}}</span>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/loading.component.html
// module id = 628
// module chunks = 1